import { render, staticRenderFns } from "./SetPasswordDialog.vue?vue&type=template&id=4cfe21e6&scoped=true"
import script from "./SetPasswordDialog.vue?vue&type=script&lang=ts"
export * from "./SetPasswordDialog.vue?vue&type=script&lang=ts"
import style0 from "./SetPasswordDialog.vue?vue&type=style&index=0&id=4cfe21e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfe21e6",
  null
  
)

export default component.exports